/**
 * @generated SignedSource<<3100c8d1cf578444e4f9b12ec7329b03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMergedSponsoredAndYmalItems_sponsoredItems$data = {
  readonly items: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItem">;
  } | null> | null;
  readonly metadata: ReadonlyArray<{
    readonly clickTrackerLink: string | null;
    readonly impressionTrackerLink: string | null;
    readonly itemId: string | null;
  } | null> | null;
  readonly " $fragmentType": "useMergedSponsoredAndYmalItems_sponsoredItems";
};
export type useMergedSponsoredAndYmalItems_sponsoredItems$key = {
  readonly " $data"?: useMergedSponsoredAndYmalItems_sponsoredItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMergedSponsoredAndYmalItems_sponsoredItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMergedSponsoredAndYmalItems_sponsoredItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SponsoredItemsMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "impressionTrackerLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clickTrackerLink",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsLanding_similarItem"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SponsoredItems",
  "abstractKey": null
};

(node as any).hash = "3404fd65576e182f5e692464b531dd2e";

export default node;
